import { FormField, Select } from '@cloudscape-design/components';
import { PPartRetiredStatuses, PPartStatus } from '@parallel-fluidics/shared/constants';
import getPPartOption from 'features/pPart/utils/getPPartOption';
import { useGetProjectParts } from 'hooks/use-basicQueries';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Part picker scoped to one row's project. Retired parts are filtered here
 * rather than in the query so an existing row pointing at one still renders
 * with its real label — plus an inline warning for any non-Active selection,
 * so the editor can't silently keep a retired reference.
 */
export default function PartRefSelect({
  projectDocId = null, pPartDocId = null, excludeTypes, excludePPartDocId = null, onChange,
}) {
  const { data: parts, isLoading } = useGetProjectParts({
    projectDocId,
    excludeTypes,
    disabled: !projectDocId,
  });
  const options = (parts || [])
    .filter((part) => !PPartRetiredStatuses.includes(part.status) && part.id !== excludePPartDocId)
    .map((part) => getPPartOption(part));
  const selectedPart = (parts || []).find((part) => part.id === pPartDocId);
  const selectedOption = (selectedPart && getPPartOption(selectedPart))
    || (pPartDocId ? { label: pPartDocId, value: pPartDocId } : null);
  const warningText = selectedPart && selectedPart.status !== PPartStatus.ACTIVE
    ? `This part is ${selectedPart.status}`
    : undefined;

  return (
    <FormField warningText={warningText} stretch>
      <Select
        selectedOption={selectedOption}
        options={options}
        statusType={isLoading && projectDocId ? 'loading' : 'finished'}
        filteringType="auto"
        expandToViewport
        placeholder="Select a part"
        empty="No parts found"
        disabled={!projectDocId}
        onChange={({ detail }) => onChange(detail.selectedOption.value)}
      />
    </FormField>
  );
}

PartRefSelect.propTypes = {
  projectDocId: PropTypes.string,
  pPartDocId: PropTypes.string,
  excludeTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  excludePPartDocId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
